/**
 * PublishCircleIcon Component
 *
 * Circle outline with a filled upload arrow and a short rail above it.
 * Used in the bulk-publish confirmation dialog (GRAIN-1577).
 *
 * Authored at 24×24 to match ActivateCircleIcon / MinusCircleIcon; path
 * coordinates are a proportional scale (×0.96) of the 25×25 Figma source
 * so the visual weight is identical at the target 24px render size.
 */

export function PublishCircleIcon({ className }: { className?: string }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="11.25" stroke="currentColor" strokeWidth="1.5" />
      <path
        d="M12.5555 11.1871V17.76H11.4445V11.1871L8.4654 14.0837L7.68 13.3201L12 9.12L16.32 13.3201L15.5347 14.0837L12.5555 11.1871Z"
        fill="currentColor"
      />
      <path d="M7.68 7.68H16.32" stroke="currentColor" />
    </svg>
  );
}
